import { render, staticRenderFns } from "./IOSSwitchButton.vue?vue&type=template&id=9d0278f0"
import script from "./IOSSwitchButton.vue?vue&type=script&lang=js"
export * from "./IOSSwitchButton.vue?vue&type=script&lang=js"
import style0 from "./IOSSwitchButton.vue?vue&type=style&index=0&id=9d0278f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports